// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46243 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 22H11.5V14H8C4.68629 14 2 16.6863 2 20V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 12H17V16.0029H15.0471L13.5 17.1395V22.5H22.5V17.1395L20.9529 16.0029H19V14H21V12Z"}}]};

const UserPasswordFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-password-filled',
    ref,
    icon: element,
  },
));

UserPasswordFilledIcon.displayName = 'UserPasswordFilledIcon';

export default UserPasswordFilledIcon;
